export const environment = {
  production: true,
  env: 'prod',
  filesUrl: 'https://onboarding-files.smilego.io',
  apiUrl: 'https://comercial.certiface.com.br',
  fortfaceSdkUrl: '/assets/fortface-sdk',
  login: 'victor.madeira.apiglobal',
  pass: '26346cc196e983263b347ff3ef7b1469',
  DeviceKeyIdentifier: "dF2CabwQ6OCLFJaV2QqZhP7OUErHv0uz",
  PublicFaceScanEncryptionKey:
    "-----BEGIN PUBLIC KEY-----\n" +
    "MIIBIjANBgkqhkiG9w0BAQEFAAOCAQ8AMIIBCgKCAQEA5PxZ3DLj+zP6T6HFgzzk\n" +
    "M77LdzP3fojBoLasw7EfzvLMnJNUlyRb5m8e5QyyJxI+wRjsALHvFgLzGwxM8ehz\n" +
    "DqqBZed+f4w33GgQXFZOS4AOvyPbALgCYoLehigLAbbCNTkeY5RDcmmSI/sbp+s6\n" +
    "mAiAKKvCdIqe17bltZ/rfEoL3gPKEfLXeN549LTj3XBp0hvG4loQ6eC1E1tRzSkf\n" +
    "GJD4GIVvR+j12gXAaftj3ahfYxioBH7F7HQxzmWkwDyn3bqU54eaiB7f0ftsPpWM\n" +
    "ceUaqkL2DZUvgN0efEJjnWy5y1/Gkq5GGWCROI9XG/SwXJ30BbVUehTbVcD70+ZF\n" +
    "8QIDAQAB\n" +
    "-----END PUBLIC KEY-----",
  ProductionKeyText: 'dinamica',
  tenant: "",
  /** Intervalo do poll de /version.json (ms). 0 ou negativo desliga o poll. */
  versionPollIntervalMs: 3 * 60 * 1000,
};